import type { PricingPlan } from "@/domain/city";
import { apiClient } from "../apiClient";

export const getPricingPlans = (cityId: number): Promise<PricingPlan[]> => {
  return apiClient
    .get("/payment-service/dashboard/v2/user/settings/cities/plans", {
      params: {
        cityId,
      },
    })
    .then((r) => r.data.currentPlans);
};
